/** 是否顯示「說明」膠囊。只看有無描述圖，無庫存也要顯示。 */
const shouldShowRedeemGuideCapsule = (product) => !!product?.descriptionImage;

export default shouldShowRedeemGuideCapsule;
